document.addEventListener('DOMContentLoaded', function () {

  var sliders = document.querySelectorAll('.ugc-slider');
  if (!sliders.length) return;

  sliders.forEach(function(slider){

    $(slider).slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      rows: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

  });

});

let tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
document.head.appendChild(tag);

const ytPlayers = {};

function onYouTubeIframeAPIReady() {
  document.querySelectorAll('.youtube-video').forEach((iframe) => {
    const videoId = iframe.dataset.videoId;
    ytPlayers[videoId] = new YT.Player(iframe, {
      events: {
        'onStateChange': (event) => {
          const wrapper = iframe.closest('.ugc-love-video-wrapper');
          const btn = wrapper.querySelector('.ugc-play-btn');
          if (event.data === YT.PlayerState.PLAYING) btn.innerHTML = '❚❚';
          else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) btn.innerHTML = '<span>▶</span>';
        }
      }
    });
  });
}
document.querySelectorAll('.ugc-play-btn').forEach((btn) => {
  btn.addEventListener('click', () => {
    const wrapper = btn.closest('.ugc-love-video-wrapper');
    const iframe = wrapper.querySelector('.youtube-video');
    const videoId = iframe.dataset.videoId;

    const player = ytPlayers[videoId];

    if (!player) return;

    const state = player.getPlayerState();

    if (state === YT.PlayerState.PLAYING) {
      player.pauseVideo();
      btn.innerHTML = '<span>▶</span>';
    } else {
      player.playVideo();
      btn.innerHTML = '❚❚';
    }
  });
});
document.querySelectorAll('.ugc-love-video-wrapper').forEach(wrapper => {
  const video = wrapper.querySelector('.ugc-video');
  const btn = wrapper.querySelector('.ugc-play-btn');

  wrapper.addEventListener('mouseenter', () => {
    if (video.tagName.toLowerCase() === 'video') {
      video.setAttribute('controls', true);
      video.controlsList = "nodownload noremoteplayback nofullscreen noplaybackrate"; // disable volume + extras
    }
  });
  wrapper.addEventListener('mouseleave', () => {
    if (video.tagName.toLowerCase() === 'video') {
      video.removeAttribute('controls');
    }
  });

  wrapper.addEventListener('click', (e) => {
    if (e.target === btn) return;

    if (video.tagName.toLowerCase() === 'video') {
      if (video.paused) video.play();
      else video.pause();
    }
  });

  btn.addEventListener('click', () => {
    if (video.tagName.toLowerCase() === 'video') {
      if (video.paused) video.play();
      else video.pause();
    } else if (video.tagName.toLowerCase() === 'iframe') {
      const player = ytPlayers[video.dataset.videoId];
      if (!player) return;
      const state = player.getPlayerState();
      if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) player.playVideo();
      else if (state === YT.PlayerState.PLAYING) player.pauseVideo();
    }
  });

  if (video.tagName.toLowerCase() === 'video') {
    video.addEventListener('play', () => btn.innerHTML = '❚❚');
    video.addEventListener('pause', () => btn.innerHTML = '<span>▶</span>');
  }
});

document.querySelectorAll('.ugc-video').forEach(video => {
  if (video.tagName.toLowerCase() === 'video') video.removeAttribute('controls');
});